export class GameLogoModel {

  /**
   * Constructor
   *
   * @param {string} normal_url
   * @param {string} retina_url
   */
  public constructor(
    public normal_url: string = null,
    public retina_url: string = null,
  ) {}

}